import { render, staticRenderFns } from "./tixian01.vue?vue&type=template&id=aab8d362&scoped=true"
import script from "./tixian01.vue?vue&type=script&lang=js"
export * from "./tixian01.vue?vue&type=script&lang=js"
import style0 from "./tixian01.vue?vue&type=style&index=0&id=aab8d362&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab8d362",
  null
  
)

export default component.exports